import { render, staticRenderFns } from "./TbSortTabs.vue?vue&type=template&id=c3b7efbc&scoped=true&"
import script from "./TbSortTabs.vue?vue&type=script&lang=js&"
export * from "./TbSortTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b7efbc",
  null
  
)

export default component.exports